// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.right-pane {
  height: fit-content;
  width: 25%;
  background: #0f172a;
  padding-left: 5px;
  overflow-y: auto;
  margin-top: -6px;
}`, "",{"version":3,"sources":["webpack://./src/components/rightpane.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,UAAU;EACV,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB","sourcesContent":[".right-pane {\n  height: fit-content;\n  width: 25%;\n  background: #0f172a;\n  padding-left: 5px;\n  overflow-y: auto;\n  margin-top: -6px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
